import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core";
import {AdminContextConsumer} from './Admin';
import MUIDataTable from "mui-datatables";
import firebaseApp from "../common/firebase";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Grid from "@material-ui/core/Grid/Grid";
import {isNullOrUndefined} from "util";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Button from "@material-ui/core/Button/Button";
import AddIcon from '@material-ui/icons/Add';
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import TextField from "@material-ui/core/TextField/TextField";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Dialog from "@material-ui/core/Dialog/Dialog";
import RefreshIcon from "@material-ui/icons/Refresh";


const firestore = firebaseApp.firestore();


const styles = theme => ({
    progress: {
        margin: theme.spacing.unit * 2,
    },
    fab: {
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});

class Cities extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            working: false,
            entries: [],
            showDialog: false,
            editMode: false,
            entry: null,
            label: "",
            lat: "0",
            lon: "0",
            options: {
                filter: false,
                selectableRows: 'multiple',
                responsive: 'scrollFullHeight',
                customToolbar: () =>
                    <Tooltip title={"Reload Data"}>
                        <IconButton
                            onClick={this.reload}>
                            <RefreshIcon/>
                        </IconButton>
                    </Tooltip>,
                customToolbarSelect: (selectedRows) =>
                    <StyledCustomToolbarSelect
                        selectedRows={selectedRows}
                        onDelete={this.handleDelete}/>

            },
            data: [],
            columns: [
                {

                    name: "Action",
                    field: "action",
                    options: {
                        filter: false,
                        sort: false,
                        customBodyRender: (value, tableMeta, updateValue) => {
                            return (
                                <Tooltip title={"Edit entry"}>
                                    <IconButton
                                        onClick={(e) => this.setState({entry: value}, () => this.openDialog(true))}>
                                        <EditIcon/>
                                    </IconButton>
                                </Tooltip>

                            );
                        },
                    },

                },
                {

                    name: "Label",
                    field: "label",
                    options: {
                        filter: false,
                        sort: true
                    }
                },
                {

                    name: "Latitude",
                    field: "lat",
                    options: {
                        filter: false,
                        sort: true
                    }
                },
                {

                    name: "Longitude",
                    field: "lon",
                    options: {
                        filter: false,
                        sort: true
                    }
                },
            ],
        };
    }


    componentDidMount() {

        this.reload();
    }

    reload = () => {
        this.setState({loading: true}, async () => {
            try {

                let fsEntries = await firestore.collection("cities").get();

                let entries = [];

                for (const fsEntry of fsEntries.docs) {
                    entries.push({...fsEntry.data(), ref: fsEntry.ref});
                }


                const data = entries.map(entry => {

                    const line = [];

                    for (const column of this.state.columns) {
                        let field = entry[column.field];

                        if (column.field === "action") {
                            field = entry;
                        }

                        if (isNullOrUndefined(field)) {
                            field = "-";
                        }

                        line.push(field);
                    }

                    return line;
                });

                this.setState({entries: entries, data: data, loading: false});
            } catch (error) {
                console.error(error);
                this.setState({loading: false});
            }

        })

    };

    handleDelete = (selectedRows) => {

        this.setState({working: true}, async () => {
            try {

                const batch = firestore.batch();

                for (const selectedRow of selectedRows.data) {

                    batch.delete(this.state.entries[selectedRow.dataIndex].ref);
                }

                await batch.commit();

                this.setState({working: false}, () => {
                    this.reload();
                });

            } catch (error) {
                console.error(error);
                this.setState({working: false});
            }

        });

    };

    handleChange = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    openDialog = (mode) => {

        if (mode) {
            this.setState({
                showDialog: true,
                label: this.state.entry.label,
                lat: this.state.entry.lat,
                lon: this.state.entry.lon,
                editMode: true
            })
        } else {
            this.setState({showDialog: true, label: "", lat: "0", lon: "0", editMode: false, entry: null})
        }
    };

    closeDialog = () => {
        this.setState({showDialog: false, label: "", lat: "0", lon: "0", editMode: false, entry: null})
    };

    handleSave = () => {
        this.setState({working: true}, async () => {

            const lat = parseFloat(this.state.lat);
            const lon = parseFloat(this.state.lon);

            if (this.state.entry) {
                await this.state.entry.ref.set({
                    label: this.state.label,
                    search: this.state.label.toLowerCase(),
                    lat: lat,
                    lon: lon,
                });

            } else {

                await firestore.collection("cities").doc().set({
                    label: this.state.label,
                    search: this.state.label.toLowerCase(),
                    lat: lat,
                    lon: lon,
                });
            }

            this.setState({
                working: false,
                showDialog: false,
                label: "",
                lat: "0",
                lon: "0",
                editMode: false,
                entry: null
            }, () => {
                this.reload();
            })
        })
    };

    render() {
        const {classes} = this.props;

        const isValidLabel = this.state.label.trim().length > 0;
        const isValidLat = !isNaN(this.state.lat);
        const isValidLon = !isNaN(this.state.lon);


        return (
            <React.Fragment>
                <AdminContextConsumer>
                    {({page}) => (
                        <React.Fragment>

                            {this.state.loading ? (
                                    <Grid
                                        container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <CircularProgress className={classes.progress} size={50}/>
                                    </Grid>
                                ) :
                                (
                                    <React.Fragment>

                                        <MUIDataTable
                                            columns={this.state.columns}
                                            data={this.state.data}
                                            title={page.title}
                                            options={this.state.options}
                                        />

                                        <Button variant="fab" className={classes.fab} color={"secondary"}
                                                onClick={(e) => this.openDialog(false)}>
                                            <AddIcon/>
                                        </Button>

                                    </React.Fragment>

                                )}


                            <Dialog
                                open={this.state.showDialog}
                                aria-labelledby="form-dialog-title"
                            >

                                {this.state.editMode ? (
                                    <React.Fragment>
                                        <DialogTitle
                                            id="form-dialog-title">Edit {this.state.label} of {page.title}</DialogTitle>
                                        <DialogContent>
                                            <DialogContentText>
                                                Edit the City values.
                                            </DialogContentText>

                                            <TextField
                                                value={this.state.label}
                                                autoFocus
                                                margin="dense"
                                                id="label"
                                                name="label"
                                                label="Label"
                                                type="text"
                                                onChange={this.handleChange}
                                                fullWidth
                                                disabled={this.state.working}
                                            />

                                            <TextField
                                                value={this.state.lat}
                                                multiline={true}
                                                margin="dense"
                                                id="lat"
                                                name="lat"
                                                label="Latitude"
                                                type="number"
                                                error={!isValidLat}
                                                helperText={!isValidLat ? "Only Lat degrees" : ""}
                                                onChange={this.handleChange}
                                                fullWidth
                                                disabled={this.state.working}
                                            />

                                            <TextField
                                                value={this.state.lon}
                                                multiline={true}
                                                margin="dense"
                                                id="lon"
                                                name="lon"
                                                label="Longitude"
                                                error={!isValidLon}
                                                helperText={!isValidLon ? "Only Lon degrees" : ""}
                                                type="number"
                                                onChange={this.handleChange}
                                                fullWidth
                                                disabled={this.state.working}
                                            />


                                        </DialogContent>

                                        <DialogActions>
                                            <Button onClick={this.closeDialog} color="primary"
                                                    disabled={this.state.working}>
                                                Close
                                            </Button>
                                            <Button onClick={this.handleSave} color="primary" autoFocus
                                                    disabled={this.state.working || !isValidLat || !isValidLon || !isValidLabel}>
                                                Save
                                            </Button>
                                        </DialogActions>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        <DialogTitle id="form-dialog-title">Add a new value
                                            to {page.title}</DialogTitle>
                                        <DialogContent>
                                            <DialogContentText>
                                                add a new value.
                                            </DialogContentText>
                                            <TextField
                                                value={this.state.label}
                                                autoFocus
                                                margin="dense"
                                                id="label"
                                                name="label"
                                                label="Label"
                                                type="text"
                                                onChange={this.handleChange}
                                                fullWidth
                                                disabled={this.state.working}
                                            />

                                            <TextField
                                                value={this.state.lat}
                                                multiline={true}
                                                margin="dense"
                                                id="lat"
                                                name="lat"
                                                label="Latitude"
                                                type="number"
                                                error={!isValidLat}
                                                helperText={!isValidLat ? "Only Lat degrees" : ""}
                                                onChange={this.handleChange}
                                                fullWidth
                                                disabled={this.state.working}
                                            />

                                            <TextField
                                                value={this.state.lon}
                                                multiline={true}
                                                margin="dense"
                                                id="lon"
                                                name="lon"
                                                label="Longitude"
                                                error={!isValidLon}
                                                helperText={!isValidLon ? "Only Lon degrees" : ""}
                                                type="number"
                                                onChange={this.handleChange}
                                                fullWidth
                                                disabled={this.state.working}
                                            />


                                        </DialogContent>

                                        <DialogActions>
                                            <Button onClick={this.closeDialog} color="primary"
                                                    disabled={this.state.working}>
                                                Close
                                            </Button>
                                            <Button onClick={this.handleSave} color="primary" autoFocus
                                                    disabled={this.state.working || !isValidLat || !isValidLon || !isValidLabel}>
                                                Save
                                            </Button>
                                        </DialogActions>
                                    </React.Fragment>
                                )}

                            </Dialog>


                        </React.Fragment>
                    )}
                </AdminContextConsumer>
            </React.Fragment>
        );
    }
}

Cities.propTypes = {
    classes: PropTypes.object.isRequired,
};

const defaultToolbarSelectStyles = {
    iconButton: {
        marginRight: "24px",
        top: "50%",
        display: "inline-block",
        position: "relative",
        transform: "translateY(-50%)",
    },
};

class CustomToolbarSelect extends React.Component {

    render() {
        const {classes} = this.props;

        return (
            <div className={"custom-toolbar-select"}>
                <Tooltip title={"Delete"}>
                    <IconButton className={classes.iconButton}
                                onClick={e => this.props.onDelete(this.props.selectedRows)}>
                        <DeleteIcon/>
                    </IconButton>
                </Tooltip>
            </div>
        );
    }

}

const StyledCustomToolbarSelect = withStyles(defaultToolbarSelectStyles, {name: "CustomToolbarSelect"})(CustomToolbarSelect);

export default withStyles(styles, {withTheme: true})(Cities)